import type { FC, ReactNode } from "react";

import { Card, CardRowSimple, type GridCard } from "widgets";

import { ProteinTile } from "../../core/tiles/index.js";
import type { ProteinMutation } from "@/graphql.ts";
import { SelMessage } from "@/messages/SelMessage.tsx";

export interface IProteinMutationsCardProps extends GridCard {
  proteinMutations: ProteinMutation[];
  ignoreIfEmpty?: boolean;
  title?: string;
  showSource?: boolean;
}

const ProteinMutationsCard: FC<IProteinMutationsCardProps> = (props) => {
  const proteinMutations: ProteinMutation[] = props.proteinMutations;
  if (props.ignoreIfEmpty && (!proteinMutations || proteinMutations.length === 0)) {
    return null;
  }

  let elements: ReactNode = <SelMessage id={"noContent.relatedProteins"} />;

  if (proteinMutations && proteinMutations.length > 0) {
    elements = proteinMutations.map((proteinMutation) => {
      const protein = proteinMutation.proteinLocation.protein;

      return (
        <ProteinTile
          protein={protein}
          key={`proteinMutation-card-elem-${proteinMutation.id}`}
          footNote={`${proteinMutation.name}, ${proteinMutation.range.start} – ${proteinMutation.range.stop}`}
        />
      );
    });
  }

  return (
    <Card
      shrinkable={props.proteinMutations.length > 5}
      icon={"sticky_note_2"}
      title={props.title ?? "Proteins"}
      tag={{ label: String(proteinMutations.length) }}
    >
      <CardRowSimple>{elements}</CardRowSimple>
    </Card>
  );
};

export default ProteinMutationsCard;
export { ProteinMutationsCard };
